export default "__VITE_ASSET__DOyTNvSx__"